export const css = {
	root: '_3lVBzp8P',
	completedNote: '_3i-3dcB4',
	contentOrRecommended: '_1jgF1O5n',
	recommendedSelected: '_3vLag9pM',
	contentSelected: 't8Qp9agd',
	contentSelectorGroup: '_3DqKNSPi',
	viewNote: '_2M83Xsi4',
	about: '_34Me4SEy',
	fieldset: 'KdYV3ubK',
	visuallyHidden: 'dqGxkaGf',
	focusable: '_16I6UUFt',
	' _key': 'explore-view/explore-view'
};

export default css;
